var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimedExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}.cls-2{fill:#f71568;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,31a1,1,0,0,1-1-1V12a3,3,0,0,1,3-3H42a3,3,0,0,1,3,3V22a1,1,0,0,1-2,0V12a1,1,0,0,0-1-1H16a1,1,0,0,0-1,1V30A1,1,0,0,1,14,31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,51H34a1,1,0,0,1,0-2h8a1,1,0,0,0,1-1V38a1,1,0,0,1,2,0V48A3,3,0,0,1,42,51Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48,39a.94.94,0,0,1-.43-.1A1,1,0,0,1,47,38V35H34a1,1,0,0,1-1-1V26a1,1,0,0,1,1-1H47V22a1,1,0,0,1,1.63-.78l10,8a1,1,0,0,1,0,1.56l-10,8A1,1,0,0,1,48,39ZM35,33H48a1,1,0,0,1,1,1v1.92L56.4,30,49,24.08V26a1,1,0,0,1-1,1H35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19,56A12,12,0,1,1,31,44,12,12,0,0,1,19,56Zm0-22A10,10,0,1,0,29,44,10,10,0,0,0,19,34Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19,45a1,1,0,0,1-1-1V37.13a1,1,0,0,1,2,0V44A1,1,0,0,1,19,45Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.5,45H19a1,1,0,0,1,0-2h5.5a1,1,0,0,1,0,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimedExit);
export default __webpack_public_path__ + "static/media/timed-exit.f0f0301e1f85ccd5dd71e9638fde5dfb.svg";
export { ForwardRef as ReactComponent };